import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: 'linear-gradient(45deg, #121212 30%, #1e1e1e 90%)',
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h1"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              background: 'linear-gradient(45deg, #2196f3 30%, #f50057 90%)',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Hi, I'm Mohsin
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            gutterBottom
            sx={{ color: 'text.secondary', mb: 4 }}
          >
            Lead Software Engineer | Full Stack Developer
          </Typography>
          <Typography
            variant="h5"
            component="p"
            sx={{ color: 'text.secondary', mb: 4, maxWidth: '600px' }}
          >
           I am seasoned full stack developer, working as lead software engineer with a global bank. I build exceptional digital experiences that make an impact. Specializing in
            creating beautiful, functional, and client-centered solutions. I have diverse experiences in building, designing scalable and secure enterprise applications, across multiple domains like Corporate Technology, Compliance and Risk, Payments Technology.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              size="large"
              component={RouterLink}
              to="/projects"
              sx={{ px: 4, py: 1.5 }}
            >
              View My Work
            </Button>
            <Button
              variant="outlined"
              size="large"
              component={RouterLink}
              to="/contact"
              sx={{ px: 4, py: 1.5 }}
            >
              Contact Me
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Home; 